var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"about"},[_c('h2',[_vm._v("About Me")]),_vm._v(" "),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('img',{attrs:{"src":"/static/photos/alyson.jpg"}})]),_vm._v(" "),_c('b-col',{},[_c('p',[_vm._v("\n        I am a natural-light freelance photographer located in the Colorado Springs, Colorado area.\n      ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee85ebe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 3GKq
// module chunks = 1